import React from 'react';
import './SectorInfo.scss';
import { Tooltip } from 'antd';

function SectorInfo({ header, riskLevel, riskDescription, style }) {
  return (
    <div className={'wrapperDiv'}>
      <h3>{header}</h3>
      <div className="sector-info-row">
          <div className="risk-column">
        <Tooltip title={riskDescription ? riskDescription : "/"} placement="right">
            <p style={style}><b>{riskLevel ? riskLevel : "/"}</b></p>
        </Tooltip>
          </div>
      </div>
    </div>
  );
}

export default SectorInfo;